import { createApp, h } from "vue";
import i18n from "./i18n";
import Buefy from "@ntohq/buefy-next";
import store from "./store";
import router from "./router";
import SimpleVueValidation from "simple-vue-validator";
import logger_module from "./logging";
import { getAxiosInstance } from "./api/instance";
import { StripePlugin } from "@vue-stripe/vue-stripe";
import VueDragResize from "vue-drag-resize";
import hybridapi from "./hybridapi";
import vuetify from "./plugins/vuetify";
import { useToast } from "vue-toastification";
import { loadStripe } from "@stripe/stripe-js";
import "vue-toastification/dist/index.css";

import App from "./App.vue";

const { localStore, STORE_KEYS } = require("./storage");

const TheURLSearchParams = window.TheURLSearchParams;

window["i18n"] = i18n;

////////////////////
// Backend Config //
////////////////////

const api_url = process.env.VUE_APP_API_URL;
const IS_PROD = process.env.NODE_ENV === "production";
store.commit("client/setProd", IS_PROD);
store.commit("setBrandName", process.env.VUE_APP_BRAND_NAME);
store.commit("setBrandTitle", process.env.VUE_APP_BRAND_TITLE);
store.commit("setEmailDomain", process.env.VUE_APP_EMAIL_DOMAIN);

i18n.silentFallbackWarn = process.env.VUE_APP_I18N_SILENT_FALLBACK_WARN;
i18n.silentTranslationWarn = process.env.VUE_APP_I18N_SILENT_TRANSLATION_WARN;

logger_module.setIsProd(IS_PROD);

// LOCALSTORE: Auth Token & Device Id
let auth_token = TheURLSearchParams.get("auth_token");
if (auth_token != null) {
  localStore.setItem(STORE_KEYS.AUTH_TOKEN, auth_token);
} else {
  auth_token = localStore.getItem(STORE_KEYS.AUTH_TOKEN);
}
store.commit("client/setAuthToken", auth_token);
let device_id = TheURLSearchParams.get("device_id");
if (device_id != null) {
  localStore.setItem(STORE_KEYS.DEVICE_ID, device_id);
} else {
  device_id = localStore.getItem(STORE_KEYS.DEVICE_ID);
}
store.commit("client/setDeviceId", device_id);

const isHybridPage =
  (TheURLSearchParams.get("auth_token") &&
    TheURLSearchParams.get("device_id")) ||
  window.location.href.indexOf("/paypal") > -1;
store.commit("client/setHybridPage", isHybridPage);

/////////////////
// The Vue App //
/////////////////
const vueApp = createApp({
  store,
  render: () => h(App),
});
vueApp.use(vuetify);

vueApp.config.globalProperties.$hybridapi = hybridapi;
vueApp.config.productionTip = false;
try {
  vueApp.config.devtools = process.env.NODE_ENV !== "production";
  // eslint-disable-next-line
} catch (ignored) {}

//Outside component add into vue
vueApp.component("vue-drag-resize", VueDragResize);

vueApp.use(i18n);
vueApp.use(store);
vueApp.use(Buefy, { defaultIconPack: "fas" });
vueApp.use(SimpleVueValidation, { mode: "conservative" });

vueApp.config.globalProperties.$axios = getAxiosInstance({
  base_url: api_url,
  auth_token: auth_token,
  device_id: device_id,
});

store.commit("client/setAxiosReady", true);
// TOAST
const toast_options = {
  transition: "Vue-Toastification__bounce",
  maxToasts: 1,
  newestOnTop: true,
  filterBeforeCreate: (toast, toasts) => {
    if (toasts.filter((t) => t.type === toast.type).length !== 0) {
      // Returning false discards the toast
      return false;
    }
    // You can modify the toast if you want
    return toast;
  },
};

window["axios"] = vueApp.config.globalProperties.$axios;
vueApp.$axios = vueApp.config.globalProperties.$axios;
vueApp.$hybrid_websocket_url = process.env.VUE_APP_HYBRID_WEBSOCKET_URL;
vueApp.$store = store;

const toast = useToast(toast_options);
vueApp.use(toast);
vueApp.$toast = toast;
window["toast"] = toast;
vueApp.config.globalProperties.$toast = toast;

// Stripe
vueApp.config.globalProperties.$stripe = await loadStripe(
  process.env.VUE_APP_STRIPE_PK
);

vueApp.use(router);
vueApp.mount("#app");

const { t } = i18n.global;

// Validation translation and registiration
SimpleVueValidation.extendTemplates({
  required: t("errors.required"),
  length: t("errors.must_be_n"),
  between: t("errors.must_be_between"),
  lengthBetween: t("errors.must_be_between"),
  email: t("errors.email_not_valid"),
  match: t("errors.not_match"),
  minLength: t("errors.password_min_8_char"),
});
